import classes from "./StatusChip.module.css";
import { useSelector } from "react-redux";
import { getStatusClass } from "../../helperFunctions/getStatusClass";
import { statusTranslations } from "../../helperFunctions/statuses";

export function StatusChip({ status, hoverText }) {
  const { language } = useSelector((state) => state.global);
  console.log(status);

  return (
    <div
      className={` ${classes[getStatusClass(status)]}`}
      style={{ cursor: status === "Postponed" ? "pointer" : "" }}
    >
      {statusTranslations[language]?.[status?.toLowerCase()] || status}
    </div>
  );
}
